import { BicycleRoute, Community } from '@/interfaces';
import Mapbox from 'mapbox-gl';
import HelperService from './helper.service';
import DataService from './data.service';
import routeCommunities from '@/assets/data/routeCommunities.json';
import projectCommunities from '@/assets/data/projectCommunities.json';
import communities from '@/assets/data/communities.json';
import locations from '@/assets/data/locations.json';
import projects from '@/assets/data/projects.json';

export default class PopoverService {
  private popup: any;
  private helperService = new HelperService();
  private dataService = new DataService();
  private communities = communities;
  private locations = locations;
  private projects = projects;
  private projectCommunities = projectCommunities;

  public removePopover(): void {
    if (!this.popup) {
      return;
    }
    window.location.hash = '';
    this.popup.remove();
  }

  public showPopover(lngLat: {lng: number, lat: number},
                     item: any, map: any,
                     closeOnClick: boolean, small: boolean, isContainer?: boolean): void {
    lngLat = (item.coordinate && small) ? {lng: item.coordinate[0], lat: item.coordinate[1]} : lngLat;
    const puHtml = this.getHtmlForPopup(item, small, isContainer);
    this.popup = new Mapbox.Popup({closeOnClick})
      .setLngLat(lngLat)
      .setHTML(puHtml)
      .addTo(map);
  }

  private getHtmlForPopup(data: {id: any}, small: boolean, isContainer): string {
    if (small) {
      return this.getSmall(data);
    }
    if (isContainer) {
      return this.getContainerPopup(data);
    }
    if (data.id.startsWith('route')) {
      return `<div id="popover-${data.id}" class="popover-inner">${this.getHtmlForBRoutePopup(data as BicycleRoute)}</div>`;
    } else if (data.id.startsWith('com')) {
      return `<div id="popover-${data.id}" class="popover-inner">${this.getHtmlForCommunity(data as Community)}</div>`;
    }
    return `<div id="popover-${data.id}" class="popover-inner">${this.getHtmlForProject(data)}</div>`;
  }

  private getHtmlForBRoutePopup(route: BicycleRoute): string {
    const communitiesForThisRoute = this.dataService.getCommunitiesForRoute(route, this.communities, routeCommunities);
    const companiesLength = this.dataService.getCompaniesByCommunities(communitiesForThisRoute);
    const startCity = this.locations.find(loc => loc.id === route.cities[0].id);
    const endCity = this.locations.find(loc => loc.id === route.cities[route.cities.length - 1].id);

    return `<div class="col managers">
    <h4>Snelfietsroute<br>${startCity.name} - ${endCity.name}</h4>
    ${route.status === 'planned' ? '' : '<p><strong>Verbindt ' + companiesLength + ' ' +  this.helperService.mapMeervoud('bedrijf', companiesLength) + ' met in totaal ' + route.numberOfEmployees + ' werknemers</strong></p>'}
    ${route.status === 'ready' ? 'Status: in gebruik' : ''}
    ${route.status === 'construction' ? 'Status: in aanleg, klaar in ' + route.completion : ''}
    ${route.status === 'planned' ? 'Status: in voorbereiding' : ''}
    </div>
    </div>`;
  }

  private getHtmlForCommunity(community: Community) {
    const companiesPerCommunity = this.dataService.getCompaniesByCommunities([community]);
    return `<div class="col managers">
    <h4>${community.name}</h4>
    <p><strong>Bestaande uit ${companiesPerCommunity} ${this.helperService.mapMeervoud('bedrijf', companiesPerCommunity)}</strong></p>
    <div class="popover-content">
    ${community.manager.name ? '<p><strong>Communitymanager:</strong></p>' : ''}
    ${community.manager.name ? `<a class="not-fat" href="https://www.brabantmobiliteitsnetwerk.nl/contact/" target="_blank">${community.manager.name}</a>` : ''}
    ${community.parkManagementOrganisation ? '<p style="margin-top: 20px"><strong>Parkmanagementorganisatie:</strong></p>' : ''}
    ${community.parkManagementOrganisation ? community.parkManagementOrganisation : ''}
    </div>
    </div>`;
  }

  private getHtmlForProject(data: any) {
    const currentProj = this.projects.find(proj => {
      return proj.id === data.id;
    });
    const communitiesForThisProject
    = this.dataService.getCommunitiesForProject(data, this.communities, this.projectCommunities);
    const communityNames = this.dataService.getCommunityNames(communitiesForThisProject);
    const communityList = this.helperService.formatList(communityNames);
    return `<div class="col managers">
    <h4>${currentProj.name}</h4>
    <div class="popover-content">
    <p><strong>Programma:</strong></p>
    <p>${currentProj.programme}</p>
    </div>
    </div>
    <div class="col companies">
    <h4>${communitiesForThisProject.length} betrokken ${this.helperService.mapMeervoud('community', communitiesForThisProject.length)}:</h4>
    <div class="popover-content">
    ${communityList || ''}
    </div>
    </div>`;
  }

  private getSmall(data: any) {
    let currentProj;
    let lidwoord = 'de';
    const type = this.dataService.getDataType(data);
    if (type === 'project') {
      currentProj = this.projects.find(proj => {
        return proj.id === data.id;
      });
      data = currentProj;
      lidwoord = 'het';
    }
    return `<div class="popover-inner non-flex"><h4 class="bmn-blue mb-0 mt-0"><strong>${this.helperService.capitalize(type)} ${data.name}</strong></h4><p class="mb-0">Klik op ${lidwoord} ${type} voor meer informatie</p></div>`;
  }

  private getContainerPopup(data: any) {
    const containingCommunities = [];
    data.containing.forEach(comId => {
      const comm = this.dataService.getCommunityById(comId, communities);
      containingCommunities.push(`<a href="#${comId}">${comm.name}</a>`);
    });
    const comList = this.helperService.formatList(containingCommunities);
    return `<div class="popover-inner non-flex"><h4 class="bmn-blue mb-0 mt-0"><strong>Diverse communities in regio ${data.name}</strong></h4><div class="popover-content">
    ${comList || ''}
    </div></div>`;
  }
}
